<template>
    <table-container>
        <data-iterator
            ref="iterator"
            :api="api"
            :filters.sync="filters"
            :fixed-filters="fixedFilters"
        >
            <template v-slot:actions>
                <slot name="actions"></slot>
            </template>

            <template slot-scope="{ items }">
                <d-table
                    :items="items"
                    :headers="headers"
                    :filters.sync="filters"
                    :row-select="true"
                    :row-action="true"
                    @onRowSelected="onRowSelected"
                >
                    <!-- cutoffTime column -->
                    <template v-slot:[`item.cutoffTime`]="{ item }">
                        {{ item.cutoffTime | transformDate }}
                    </template>

                    <!-- deliveryTime column -->
                    <template v-slot:[`item.deliveryTime`]="{ item }">
                        {{ item.deliveryTime | transformDate }}
                    </template>

                    <!-- pickupOffset column -->
                    <template v-slot:[`item.pickupOffset`]="{ item }">
                        {{
                            item.deliveryTime
                                | transformDate(-Number(item.pickupOffset))
                        }}
                    </template>

                    <!-- isRecurring column -->
                    <template v-slot:[`item.isRecurring`]="{ item }">
                        {{ item.isRecurring ? 'Yes' : 'No' }}
                    </template>

                    <!-- role column -->
                    <template v-slot:[`item.userRoles`]="{ item }">
                        <template v-if="item.userRoles && item.userRoles[0]">
                            {{ $t('roles.' + item.userRoles[0].role) }} <br />
                            <span
                                v-if="item.userRoles[0].company"
                                class="lower"
                            >
                                {{ item.userRoles[0].company.name }}
                            </span>
                            <span
                                v-if="item.userRoles[0].restaurant"
                                class="lower"
                            >
                                {{ item.userRoles[0].restaurant.name }}
                            </span>
                        </template>
                    </template>

                    <!-- row actions -->
                    <template v-slot:rowActions="{ item }">
                        <edit-button :to="getEditLink(item)"></edit-button>
                        <delete-action
                            :entity-name="item.name"
                            :entity-id="item.id"
                            :api="api"
                            @deleted="onEntityDeleted"
                            @failed="onEntityDeleteFailed"
                        ></delete-action>
                    </template>
                </d-table>
            </template>

            <!-- batch actions -->
            <template v-slot:batchActions>
                <delete-batch-action
                    :selected-ids="selectedIds"
                    :api="api"
                    @finished="onBatchDeleteFinished"
                    @finishedWithErrors="onBatchDeleteFinishedWithErrors"
                    @canceled="onBatchDeleteCanceled"
                ></delete-batch-action>
            </template>
        </data-iterator>
    </table-container>
</template>

<script>
import routeType from '@/router/routeType'
import RestApiType from '@/api/RestApiType'
import DataIteratorMixin from '@/components/mixins/DataIteratorMixin'
import DataTableMixin from '@/components/mixins/DataTableMixin'
import AuthMixin from '@/components/mixins/AuthMixin'
import SelectApiClientType from '@/api/SelectApiClientType'
import Headers from '@/pages/residentialCanteens/addresses/mixins/Headers'

export default {
    mixins: [DataIteratorMixin, DataTableMixin, AuthMixin, Headers],
    props: {
        fixedFilters: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data() {
        return {
            api: RestApiType.RESIDENTIAL_CANTEEN_ADDRESSES,
            selectApiClientType: SelectApiClientType,
        }
    },
    computed: {
        tableName() {
            return this.$t('labels.users')
        },
    },
    methods: {
        reload() {
            this.$refs.iterator.updateItems()
        },
        getEditLink(item) {
            return {
                name: routeType.RESIDENTIAL_CANTEEN_ADDRESSES_EDIT,
                params: { entityId: item.id },
            }
        },
    },
}
</script>
